import { Component, OnInit, Input, Output, EventEmitter, Optional, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TaxReturnService } from '../../../../../swaggerServices/api/api';
import { ITaxReturn } from '../../../../app/tax-returns/tax-return/model/i-tax-return';
import { TaxReturnStatus } from '../../../../app/tax-returns/tax-return/model/status';
import { ConfigStateService } from "../../../../app/config/config-state.service";
import { TenantConfigService } from '../../../services/tenant-config.service';
import { Subscription } from 'rxjs';
import { TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'taxreturn-approval-confirmation',
    templateUrl: './approval-confirmation.component.html',
    styleUrls: ['./approval-confirmation.component.scss'],
    standalone: false
})
export class TaxreturnApprovalConfirmationComponent implements OnInit {
  taxReturn: ITaxReturn;
  @Output() closed = new EventEmitter();
  @Output() completed = new EventEmitter();

  private dialogData: { taxReturn: ITaxReturn } = inject(MAT_DIALOG_DATA);

  constructor(
    private taxReturnService: TaxReturnService,
    public configStateService: ConfigStateService,
    private translocoService: TranslocoService,
    @Optional() private dialogRef?: MatDialogRef<TaxreturnApprovalConfirmationComponent>
    ) {
      this.taxReturn = this.dialogData.taxReturn;
    }

  isDGL: boolean = false;
  employerApproved: boolean = this.configStateService.config.tenant === 'sg' ? false : true;
  taxpayerApproved: boolean = this.configStateService.config.tenant === 'sg' ? false : true;
  submitSuccessMsg: string = '';
  submitFailureMsg: string[] = [];
  displayFlag: string = "submissionForm";
  isLoading: boolean = false;
  subscriptions: Subscription[] = [];
  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  taxpayerAlias: string;

  ngOnInit() {
    this.setRequiredApproval();
    this.subscriptions.push(
      this.configStateService.loadConfig().subscribe(configStateService => {
        this.uiConfig = new TenantConfigService(configStateService);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
        this.taxpayerAlias = this.uiConfig.config.taxpayerAlias;
        this.translocoService.selectTranslate('tax-payer-alias').subscribe(value => this.taxpayerAlias = value);
        this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
      })
    );
  }

  confirmApproval() {
    this.isLoading = true;
    const request = {
      employerAccepted: this.employerApproved,
      taxpayerAccepted: this.taxpayerApproved
    }
    this.taxReturnService.updateTaxReturnWithTaxpayerAccepted(this.taxReturn.id, request).subscribe((response: any) => {
      this.submitSuccessMsg = response.lodgeOutcome;
      this.displayFlag = 'successMessage';
      this.isLoading = false;
    }, (response: any) => {
      this.displayFlag = "errorMessage";
      this.isLoading = false;
      this.submitFailureMsg = response.error;

    }
    );
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.closed.emit();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private setRequiredApproval() {
    const DGLStatuses = [
      TaxReturnStatus.TAXPAYER_SUBMITTED_EMPLOYER_FAILED.id,
      TaxReturnStatus.AMENDMENT_TAXPAYER_SUBMITTED_EMPLOYER_FAILED.id,
      TaxReturnStatus.REVISION_TAXPAYER_SUBMITTED_EMPLOYER_FAILED.id,
      TaxReturnStatus.AWAITING_TAXPAYER_EMPLOYER_APPROVAL.id,
      TaxReturnStatus.AMENDMENT_AWAITING_TAXPAYER_EMPLOYER_APPROVAL.id,
      TaxReturnStatus.REVISION_AWAITING_TAXPAYER_EMPLOYER_APPROVAL.id
    ];

    const employerOnlyStatuses = [
      TaxReturnStatus.AWAITING_EMPLOYER_APPROVAL.id,
      TaxReturnStatus.REVISION_AWAITING_EMPLOYER_APPROVAL.id,
      TaxReturnStatus.AMENDMENT_AWAITING_EMPLOYER_APPROVAL.id,
      TaxReturnStatus.TAXPAYER_APPROVED_EMPLOYER_FAILED.id,
      TaxReturnStatus.AMENDMENT_TAXPAYER_APPROVED_EMPLOYER_FAILED.id,
      TaxReturnStatus.REVISION_TAXPAYER_APPROVED_EMPLOYER_FAILED.id,
    ];

    const taxpayerOnlyStatuses = [
      TaxReturnStatus.AWAITING_TAXPAYER_APPROVAL.id,
      TaxReturnStatus.REVISION_AWAITING_TAXPAYER_APPROVAL.id,
      TaxReturnStatus.AMENDMENT_AWAITING_TAXPAYER_APPROVAL.id
    ];

    if (DGLStatuses.includes(this.taxReturn.status)) {
      this.isDGL = true;
    } else if (employerOnlyStatuses.includes(this.taxReturn.status)) {
      this.isDGL = false;
      this.employerApproved = true;
    } else if (taxpayerOnlyStatuses.includes(this.taxReturn.status)) {
      this.isDGL = false;
      this.taxpayerApproved = true;
    }

  }

}
